module.exports = __webpack_public_path__ + "static/img/chuzhongwuli2.03ba6580.jpg";